<template>
  <div>
    <PageTitle
      :titleText="
        `申込マスタ${$route.params.allocation_id == '' ? '新規登録' : '編集'}`
      "
    ></PageTitle>
    <el-col :span="24">
      <el-divider>申込情報</el-divider>
      <el-form ref="form" :model="form" label-width="25%" :rules="rules">
        <el-form-item label="パターン" prop="type">
          <el-select
            v-model="form.type"
            placeholder="パターン"
            @change="onChangeSelect"
          >
            <el-option
              v-for="item in types"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="受付期間" prop="reception_range">
          <el-date-picker
            popper-class="reception_range"
            v-model="form.reception_range"
            type="datetimerange"
            range-separator="〜"
            start-placeholder="開始日時"
            end-placeholder="終了日時"
            format="yyyy-MM-dd HH:mm"
            @change="onChange"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="受付期間(自動)" prop="reception_date">
          <el-date-picker
            popper-class="reception_range"
            v-model="form.reception_date"
            type="datetime"
            range-separator="〜"
            start-placeholder="開始日時"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <span>&nbsp;〜</span>
        </el-form-item>
        <el-form-item label="抽選中(自動)" prop="lottery_date">
          <el-date-picker
            popper-class="lottery_date"
            v-model="form.lottery_date"
            type="datetime"
            range-separator="〜"
            start-placeholder="開始日時"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <span>&nbsp;〜</span>
        </el-form-item>
        <el-form-item label="抽選結果公開(自動)" prop="result_date">
          <el-date-picker
            popper-class="result_date"
            v-model="form.result_date"
            type="datetime"
            range-separator="〜"
            start-placeholder="開始日時"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <span>&nbsp;〜(※抽選が保存されてる場合のみ自動変更されます)</span>
        </el-form-item>
        <el-form-item label="終了(自動)" prop="finish_date">
          <el-date-picker
            popper-class="finish_date"
            v-model="form.finish_date"
            type="datetime"
            range-separator="〜"
            start-placeholder="開始日時"
            format="yyyy-MM-dd HH:mm"
          >
          </el-date-picker>
          <span>&nbsp;〜(※抽選が保存されてる場合のみ自動変更されます)</span>
        </el-form-item>
        <el-form-item label="ステータス" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio
              :label="item"
              v-for="item in statuses"
              :key="item"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="備考" prop="memo">
          <ckeditor
            ref="body_editor"
            :editor="editor"
            v-model="form.memo"
            :config="editorConfig"
          ></ckeditor>
        </el-form-item>
        <el-form-item label="抽選中テキスト" prop="lottery_text">
          <ckeditor
            ref="lottery_editor"
            :editor="editor"
            v-model="form.lottery_text"
            :config="editorConfig"
          ></ckeditor>
        </el-form-item>
        <el-form-item label="抽選結果テキスト" prop="result_text">
          <ckeditor
            ref="result_editor"
            :editor="editor"
            v-model="form.result_text"
            :config="editorConfig"
          ></ckeditor>
        </el-form-item>
        <el-divider>詳細情報</el-divider>
        <el-form-item align="right">
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="uploadCSV"
            :auto-upload="false"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :headers="header"
            :data="{ allocation: form._id }"
          >
            <el-button
              slot="trigger"
              size="small"
              type="primary"
              :disabled="form.status != '未公開'"
              >csvファイル選択</el-button
            >
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              @click="submitUpload"
              :disabled="form.status != '未公開'"
            >
              アップロード
            </el-button>
            <el-button
              style="margin-left: 10px"
              icon="el-icon-circle-plus"
              size="small"
              type="primary"
              @click="onEditArea()"
              :disabled="form.status != '未公開'"
              >追加</el-button
            >
            <el-button
              style="margin-left: 10px"
              icon="el-icon-circle-plus"
              size="small"
              type="primary"
              @click="onEditAreaMoving()"
              :disabled="form.status != '未公開'"
              >引越し初期化</el-button
            >

            <el-button size="small" @click="csvDialogVisible = true"
              >CSVサンプル</el-button
            >
          </el-upload>
        </el-form-item>
        <el-table :data="areas" style="width: 100%">
          <el-table-column prop="block" label="ブロック" width="100" sortable>
          </el-table-column>
          <el-table-column prop="type" label="種別" sortable> </el-table-column>
          <el-table-column prop="no" label="番号" width="100" sortable>
          </el-table-column>
          <el-table-column
            prop="length"
            label="全長(mm)"
            width="100"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="width"
            label="全幅(mm)"
            width="100"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="height"
            label="全高(mm)"
            width="100"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="weight"
            label="車両重量(kg)"
            width="120"
            align="right"
          >
          </el-table-column>

          <el-table-column
            prop="totalWeight"
            label="総重量(kg)"
            width="120"
            align="right"
          >
          </el-table-column>

          <el-table-column
            prop="lowWeight"
            label="重量下限(kg)"
            width="120"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="fee"
            label="料金(税込)"
            width="100"
            align="right"
          >
          </el-table-column>
          <el-table-column prop="number" label="台数" width="100" align="right">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="onEditArea(scope.$index)"
                >編集</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.native.prevent="onRemoveArea(scope.$index)"
                >削除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-form-item
          >同一ブロック内でのサイズや重量は最初に出現したデータの値が使用されます</el-form-item
        >
        <el-divider></el-divider>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button type="danger" @click="onDelete" :disabled="isCreate"
            >削除</el-button
          >
          <el-button @click="$router.push({ name: 'admin-allocation-index' })"
            >戻る</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
    <el-dialog
      title="区画情報"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form ref="area" :model="area" label-width="25%" :rules="areaRules">
        <el-form-item label="ブロック" prop="block">
          <el-input v-model="area.block"></el-input>
        </el-form-item>
        <el-form-item label="種別" prop="type">
          <el-input v-model="area.type"></el-input>
        </el-form-item>
        <el-form-item label="番号" prop="no">
          <el-input v-model="area.no"></el-input>
        </el-form-item>
        <el-form-item label="全長" prop="length">
          <el-input v-model.number="area.length"></el-input>
        </el-form-item>
        <el-form-item label="全幅" prop="width">
          <el-input v-model.number="area.width"></el-input>
        </el-form-item>
        <el-form-item label="全高" prop="height">
          <el-input v-model.number="area.height"></el-input>
        </el-form-item>
        <el-form-item label="車両重量" prop="weight">
          <el-input v-model.number="area.weight"></el-input>
        </el-form-item>
        <el-form-item label="総重量" prop="weight">
          <el-input v-model.number="area.totalWeight"></el-input>
        </el-form-item>
        <el-form-item label="重量下限" prop="lowWeight">
          <el-input v-model.number="area.weight"></el-input>
        </el-form-item>
        <el-form-item label="料金" prop="fee">
          <el-input v-model.number="area.fee"></el-input>
        </el-form-item>
        <el-form-item label="台数" prop="number">
          <el-input v-model.number="area.number"></el-input>
        </el-form-item>
        <el-form-item label="備考" prop="memo">
          <el-input type="textarea" v-model="area.memo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">キャンセル</el-button>
        <el-button type="primary" @click.native.prevent="onSaveArea"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="CSVサンプル" :visible.sync="csvDialogVisible" width="50%">
      <pre>{{ csvStr }}</pre>
      <br />
      <ul>
        <li>ヘッダ名は変更しないでください</li>
        <li>
          全長、全幅、全高、重量は半角数字。必要ない場合は0を入力してください
        </li>
        <li>備考はダブルクオーテーションで囲んでください。複数行入力可能。</li>
        <li>
          申込画面で表示されるデータは各ブロックの１番目のデータが使用されます
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadCSV">ダウンロード</el-button>
        <el-button @click="csvDialogVisible = false">閉じる</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import AllocationAreaService from "@/services/allocation-area.service";
import authHeader from "@/services/auth-header";
import CKEditor from "@ckeditor/ckeditor5-vue2";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ClassicEditor from "../../../libs/ckeditor5-build-classic";
import Admin from "../../../mixin/guard/admin";
import PageTitle from "@/components/PageTitle.vue";
export default {
  mixins: [Admin],
  components: {
    ckeditor: CKEditor.component,
    PageTitle,
  },
  watch: {
    $route(to) {
      console.log(to);
      this.reload();
    },
  },
  computed: {
    isCreate() {
      return this.id == undefined || this.id == null;
    },
    header: function() {
      return authHeader();
    },
  },
  data() {
    return {
      csvStr: "",
      types: [],
      statuses: [],
      id: null,
      dialogVisible: false,
      csvDialogVisible: false,
      areas: [],
      defalultArea: {
        allocation: null,
        block: "",
        type: "",
        no: "",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        totalWeight: 0,
        lowWeight: 0,
        memo: "",
        fee: 0,
        number: 0,
        lottery_text: "",
        result_text: "",
      },
      defalultMovingArea: {
        allocation: null,
        block: "引越し",
        type: "申し込み",
        no: "抽選",
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        totalWeight: 0,
        lowWeight: 0,
        memo: "",
        fee: 0,
        number: 0,
        lottery_text: "",
        result_text: "",
      },
      area: {},
      form: {
        _id: null,
        mansion: null,
        type: "車両",
        reception_range: [],
        reception_date: "",
        lottery_date: "",
        result_date: "",
        finish_date: "",
        name: "",
        status: "未公開",
        memo: "",
        lottery_text: "",
        result_text: "",
      },
      rules: {
        mansion: [],
        reception_range: [
          {
            required: true,
            message: "受付期間を設定してください",
            trigger: "blur",
          },
        ],
        status: [],
        type: [
          {
            required: true,
            message: "パターンを選択してください",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "名称を入力してください",
            trigger: "blur",
          },
        ],
      },
      areaRules: {
        allocation: [],
        block: [
          {
            required: true,
            message: "ブロックを入力してください",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "種別を入力してください",
            trigger: "blur",
          },
        ],
        no: [
          {
            required: true,
            message: "番号を入力してください",
            trigger: "blur",
          },
        ],
        length: [
          { required: true, message: "全長を入力してください。(無い場合は0)" },
          {
            type: "number",
            min: 0,
            max: 999999,
            message: "0〜999999までの数字を入力してください",
          },
        ],
        width: [
          { required: true, message: "全幅を入力してください。(無い場合は0)" },
          {
            type: "number",
            min: 0,
            max: 999999,
            message: "0〜999999までの数字を入力してください",
          },
        ],
        height: [
          { required: true, message: "全高を入力してください。(無い場合は0)" },
          {
            type: "number",
            min: 0,
            max: 999999,
            message: "0〜999999までの数字を入力してください",
          },
        ],
        weight: [
          { required: true, message: "重量を入力してください。(無い場合は0)" },
          {
            type: "number",
            min: 0,
            max: 999999,
            message: "0〜999999までの数字を入力してください",
          },
        ],
        memo: [],
      },
      uploadCSV: `${process.env.VUE_APP_API_ENDPOINT}/v1/allocation-area-upload`,
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        fontFamily: {
          options: [
            "default",
            "Helvetica Neue,Arial,Hiragino Kaku Gothic ProN,Hiragino Sans,Meiryo,sans-serif",
            "Times New Roman, YuMincho, Hiragino Mincho ProN, Yu Mincho, MS PMincho, serif",
            'UD デジタル 教科書体 NK-R", "Noto Sans JP", 游ゴシック体, YuGothic, "游ゴシック Medium", "Yu Gothic Medium", 游ゴシック, "Yu Gothic", メイリオ, sans-serif',
          ],
        },
        toolbar: {
          items: [
            // "heading",
            // "|",
            "bold",
            "italic",
            "underline",
            // "strikethrough",
            // "code",
            // "subscript",
            // "superscript",
            "|",
            "fontSize",
            "fontFamily",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "alignment",
            "link",
            "bulletedList",
            "numberedList",
            "imageUpload",
            "blockQuote",
            // "insertTable",
            // "mediaEmbed",
            "undo",
            "redo",
            "|",
            "sourceEditing",
          ],
        },
        simpleUpload: {
          // The URL that the images are uploaded to.
          uploadUrl: `${process.env.VUE_APP_API_ENDPOINT}/v1/file/img`,

          // Enable the XMLHttpRequest.withCredentials property.
          withCredentials: false,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: authHeader(),
        },
      },
    };
  },
  async mounted() {
    await this.reload();
    fetch(`/static/sample/allocation_sample.csv`)
      .then(response => response.text())
      .then(content => {
        console.log(content);
        this.csvStr = content;
      })
      .catch(error => {
        console.error("Error fetching the file:", error);
      });
  },
  methods: {
    onChangeSelect(e) {
      console.log("onChangeSelect", e);
      if (e == "引越し") {
        this.area = this.defalultMovingArea;
      } else {
        this.area = this.defalultArea;
      }
    },
    downloadCSV() {
      console.log("downloadCSV");
      const download = document.createElement("a");
      //リンク先に上記で生成したURLを指定する
      download.href = `/static/sample/allocation_sample.csv`;
      //download属性にファイル名を指定する
      download.download = "区間サンプル.csv";
      //作成したリンクをクリックしてダウンロードを実行する
      download.click();
    },
    onChange(obj) {
      // 日時を丸める
      console.log("onChange:", obj);
      const start = this.$date(obj[0]).tz().format("YYYY-MM-DD HH:mm");
      const end = this.$date(obj[1]).tz().format("YYYY-MM-DD HH:mm");
      this.form.reception_range = [this.$date(start), this.$date(end)];
    },

    beforeUpload() {
      if (this.isCreate) {
        alert("先に保存してください");
      }
      return !this.isCreate;
    },
    async reload() {
      this.id = this.$route.params.allocation_id;
      console.log("reload:", this.id);
      this.types = await AllocationService.getTypes();
      console.log(this.types);

      this.statuses = await AllocationService.getStatuses();
      console.log(this.statuses);

      if (this.id) {
        const response = await AllocationService.findByID(this.id);
        this.form = response.data;
        console.log("form:", this.form);
        await this.reloadAreas(this.form._id);
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    onSuccess(obj) {
      console.log(obj);
      this.$message({
        message: obj.message,
        type: "success",
      });
      this.$refs["upload"].clearFiles();
      this.reloadAreas(this.form._id);
    },
    async reloadAreas(id) {
      const response = await AllocationAreaService.find({ allocation: id });
      console.log("response:", response);
      this.areas = response.data;
    },
    onSubmit() {
      const self = this;
      this.$refs["form"].validate(valid => {
        console.log("valid:", valid);
        if (valid) {
          console.log("submit!!", self.form);
          if (self.form._id) {
            console.log("update");
            AllocationService.update(self.form)
              .then(res => {
                console.log("res:", res);
                self.$message.success("更新しました");
                // self.$router.go(-1);
                // self.$router.go({
                //   path: self.$router.currentRoute.path,
                //   force: true,
                // });
                self.$router.push({ name: "admin-allocation-index" });
              })
              .catch(err => {
                console.log("err:", err);
              });
          } else {
            console.log("create");
            self.form.mansion = self.currentUser.mansion._id;
            AllocationService.create(self.form)
              .then(res => {
                console.log("res:", res);
                console.log("id:", res.data._id);
                self.$message.success("登録しました");
                self.$router.push({
                  name: "admin-allocation-edit",
                  params: { allocation_id: res.data._id },
                  force: true,
                });
              })
              .catch(err => {
                console.log("err:", err);
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async onDelete() {
      console.log("onDelete");
      if (!confirm("削除しても良いですか？")) {
        return;
      }
      // eslint-disable-next-line
      const result = await AllocationService.delete(this.form._id);
      this.$message({
        type: "success",
        message: "削除しました",
      });
      this.$router.push({ name: "admin-allocation-index" });
    },
    async onEditArea(index) {
      if (this.isCreate) {
        alert("先に保存してください");
        return;
      }
      console.log("onEditArea:", index);
      if (index >= 0 && index < this.areas.length) {
        this.area = this.areas[index];
        console.log("area:", this.area);
      } else {
        this.area = this.defalultArea;
        this.area.allocation = this.form._id;
      }
      this.dialogVisible = true;
    },
    async onEditAreaMoving(index) {
      if (this.isCreate) {
        alert("先に保存してください");
        return;
      }
      console.log("onEditArea:", index);
      if (index >= 0 && index < this.areas.length) {
        this.area = this.areas[index];
        console.log("area:", this.area);
      } else {
        this.area = this.defalultMovingArea;
        this.area.allocation = this.form._id;
      }
      this.dialogVisible = true;
    },
    async onRemoveArea(index) {
      if (confirm("削除しますか？")) {
        console.log("onRemoveArea:", index);
        const area = this.areas[index];
        console.log("area:", area);
        const res = await AllocationAreaService.delete(area._id);
        console.log("res:", res);
        this.reloadAreas(this.form._id);
      }
    },
    handleClose() {
      console.log("handleClose");
      this.dialogVisible = false;
    },
    onSaveArea() {
      console.log("onSaveArea", this.area);
      const self = this;
      this.$refs["area"].validate(valid => {
        console.log("valid:", valid);
        if (valid) {
          console.log("submit!!", this.area);
          if (this.area._id) {
            console.log("update");
            AllocationAreaService.update(this.area)
              .then(res => {
                console.log("res:", res);
                this.$message.success("更新しました");
                this.dialogVisible = false;
                self.reloadAreas(this.form._id);
                // this.$router.go(0);
              })
              .catch(err => {
                console.log("err:", err);
              });
          } else {
            console.log("create");
            AllocationAreaService.create(this.area)
              .then(res => {
                console.log("res:", res);
                this.$message.success("登録しました");
                this.dialogVisible = false;
                self.reloadAreas(this.form._id);
                // this.$router.go(0);
              })
              .catch(err => {
                console.log("err:", err);
              });
          }
          this.dialogVisible = false;
        }
      });
    },
  },
};
</script>

<style>
/*.reception_range .el-time-spinner .el-time-spinner__wrapper:nth-child(2) {
  visibility: hidden;
}*/
</style>
